import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// To-do tool list page: drag rows inside and between lists (PATCH reorder with list + position) and drag whole lists by their header
// (PATCH move). On a failed request the element goes back where it was.
export default class extends Controller {
  static targets = ["lists", "todos"]

  connect() {
    this.sortables = []

    if (this.hasListsTarget) {
      this.sortables.push(Sortable.create(this.listsTarget, {
        animation: 150,
        handle: ".pm-list-header",
        draggable: ".pm-list",
        ghostClass: "opacity-30",
        onEnd: this.onListEnd.bind(this)
      }))
    }

    this.todosTargets.forEach((container) => {
      this.sortables.push(Sortable.create(container, {
        group: "pm-list",
        animation: 150,
        handle: ".pm-row-handle",
        draggable: ".pm-row",
        ghostClass: "opacity-30",
        dragClass: "shadow-xl",
        onEnd: this.onRowEnd.bind(this)
      }))
    })
  }

  disconnect() {
    this.sortables.forEach((sortable) => sortable.destroy())
  }

  async onRowEnd(event) {
    const { item, to, from, oldIndex, newIndex } = event
    if (to === from && oldIndex === newIndex) return

    const ok = await this.patch(item.dataset.todoReorderUrl, {
      todo_list_id: to.dataset.listId,
      position: newIndex + 1
    })
    if (!ok) this.revert(item, from, oldIndex, newIndex)
  }

  async onListEnd(event) {
    const { item, oldIndex, newIndex } = event
    if (oldIndex === newIndex) return

    const ok = await this.patch(item.dataset.listMoveUrl, { position: newIndex + 1 })
    if (!ok) this.revert(item, this.listsTarget, oldIndex, newIndex)
  }

  revert(item, container, oldIndex, newIndex) {
    const sameContainer = item.parentElement === container
    const index = sameContainer && newIndex < oldIndex ? oldIndex + 1 : oldIndex
    const reference = container.children[index]
    if (reference) {
      container.insertBefore(item, reference)
    } else {
      container.appendChild(item)
    }
  }

  async patch(url, body) {
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify(body)
      })
      return response.ok
    } catch {
      return false
    }
  }
}
